import { render, staticRenderFns } from "./TourQuestions.vue?vue&type=template&id=8e0b4e02&scoped=true&"
import script from "./TourQuestions.vue?vue&type=script&lang=js&"
export * from "./TourQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0b4e02",
  null
  
)

export default component.exports